const flags = {
  edcr: process.env.REACT_APP_ENABLE_EDCR === "true",
  selfCert: process.env.REACT_APP_ENABLE_SELF_CERT === "true",
  selfApproval: process.env.REACT_APP_ENABLE_SELF_APPROVAL === "true",
  selfApprovalScheme: process.env.REACT_APP_ENABLE_SELF_APPROVAL_SCHEME === "true",
  selfApprovalNonScheme: process.env.REACT_APP_ENABLE_SELF_APPROVAL_NON_SCHEME === "true",
  revalidation: process.env.REACT_APP_ENABLE_REVALIDATION === "true",
  groupHousing: process.env.REACT_APP_ENABLE_GROUP_HOUSING === "true",
  plinth: process.env.REACT_APP_ENABLE_PLINTH === "true",
  landUseConversion: process.env.REACT_APP_ENABLE_LANDUSE_CONVERSION === "true",
  workCommencement: process.env.REACT_APP_ENABLE_WORK_COMMENCEMENT === "true",
  purchasableFar: process.env.REACT_APP_ENABLE_PURCHASABLE_FAR === "true",
  completion: process.env.REACT_APP_ENABLE_COMPLETION === "true",
  compounding:process.env.REACT_APP_ENABLE_COMPOUNDING === "true",
};

export default flags;
